import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";
import CartaContabilita from "components/CartaContabilita";
import CartaContabilitaAQ from "components/CartaContabilita/AQ.js";
import DettaglioCommessa from "../commessa/recapCommessa.js"

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import CircularProgress from '@mui/material/CircularProgress';

import * as ajax from "helpers/ajax";
import { valid } from "chroma-js";
import { isAccordoQuadro,getAQPassedDays,calculateImportoContrattuale, calculateBudgetReal, calculateMarkupReal, toPrice, getWorkedDaysNumber, toEuropeanDate, calculateFinalDate, laborCostCommessa, calculateSAL, materialCostCommessa, daysBetween, toDashDate } from "helpers/functions.js"
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';





export default class DettaglioContabilita extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        }
    }

    componentDidMount=()=>{
        this.load()
    }

    load = () => {

        if (isAccordoQuadro(this.state.data)) {
            let filter = "";
            this.state.data.incarichi.map((el, index) => {
                filter += "&filters[commessa][id][$in][" + index + "]=" + el.id;
            })

            ajax.ajaxGetStrapi("operai-commesses?populate=operaio" + filter, this.loadWorker)
            ajax.ajaxGetStrapi("sal-commessas?" + filter, this.loadSal)
        } else {
            ajax.ajaxGetStrapi("operai-commesses?populate=operaio&filters[commessa][id]=" + this.state.data.id, this.loadWorker)
            ajax.ajaxGetStrapi("sal-commessas?filters[commessa][id][$eq]=" + this.state.data.id, this.loadSal)
        }
    }

    loadWorker = (response) => {
        this.setState({ worker: response.data, workerLoaded: true });
    }

    loadSal = (response) => {
        this.setState({ sal: response.data, salLoaded: true });
    }

    convertDate = (date) => {
        if (!date) return null;
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }



    totalDuration = () => {
        let duration = this.state.data.durata;
        let duration2 = this.state.data.proroga;

        if (isNaN(parseInt(duration))) {
            duration = 0;
        }
        if (isNaN(parseInt(duration2))) {
            duration2 = 0;
        }

        return parseInt(duration) + parseInt(duration2);
    }

    getBusinessDatesCount = (startDate, duration, returnType = "endDate") => {
        if (!startDate) {
            return 0
        }

        let count = 0;
        let workedDays = 0;

        const curDate = new Date(startDate);
        const endDate = new Date(startDate)
        endDate.setDate(endDate.getDate() + duration);

        while (curDate <= endDate) {
            const dayOfWeek = curDate.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                count++;
                if (new Date() > curDate) {
                    workedDays++;
                }
            } else {
                //festivi
                endDate.setDate(endDate.getDate() + 1);
            }
            curDate.setDate(curDate.getDate() + 1);
        }

        switch (returnType) {
            case "endDate": return endDate;
            case "workingDays": return workedDays;
        }

        return endDate;
    }

    sumOrder = () => {
        let n = 0;
        if (!this.state.data.fc_ordini) { return 0 }
        this.state.data.fc_ordini.map((el) => {
            n += el.amount_gross
        })
        n += laborCostCommessa(this.state.worker, null, this.state.data.id);

        return n.toFixed(2)
    }



    orderPercentage = () => {
        if (!this.state.data.costo_ordini) { return 0 }

        let n = ((this.sumOrder() * 100) / (this.state.data.costo_ordini + this.state.data.costo_manodopera)).toFixed(2);
        if (n > 100) { return 100 }
        return n
    }

    listYear = (endYear) => {
        let startYear = new Date(this.state.data.data_inizio).getFullYear();

        if (this.state.data.incarichi.length > 0) {
            this.state.data.incarichi.map((incarico) => {
                incarico.fc_ordini.map((el) => {
                    if (new Date(el.date).getFullYear() < startYear) {
                        startYear = new Date(el.date).getFullYear();
                    }
                })
            })
        } else {
            this.state.data.fc_ordini.map((el) => {
                if (new Date(el.date).getFullYear() < startYear) {
                    startYear = new Date(el.date).getFullYear();
                }
            })
        }

        global.workers.data.map((el) => {
            if (el.commessa.id==this.state.data.id) {
                if (new Date(el.data).getFullYear() < startYear) {
                    startYear = new Date(toEuropeanDate(el.data)).getFullYear();
                }
            }
        })

        var result = [];
        for (var from = startYear, to = endYear; from <= to; from++)
            result.push(from);

        return result;
    }

    renderYear = (startDate, endDate, title, data) => {
        
        let materialCost = materialCostCommessa(data, startDate, endDate);
        let laborCost = laborCostCommessa(this.state.worker, startDate, endDate, data.id);

        if (isAccordoQuadro(data)) {
            materialCost = 0;
            data.incarichi.map((el) => {
                materialCost += materialCostCommessa(el, startDate, endDate);
            })
        }

        let markupReal = calculateMarkupReal(data, materialCost, laborCost, startDate, endDate);
        let budgetReale = calculateBudgetReal(data, markupReal, startDate, endDate)


        return (
            <MDBox
                bgColor="white"
                borderRadius="lg"
                shadow="lg"
                p={2}
                mt={1}
            >
                <Grid container>
                    <Grid item sm={3}>
                        {title}
                    </Grid>
                    <Grid item sm={9}>
                        <Grid container>
                            <MDTypography variant="button" fontWeight="medium">COSTO MANODOPERA EFFETTIVO:</MDTypography>
                            <MDTypography variant="button" ml={1}>{toPrice(laborCost)}</MDTypography>
                        </Grid>
                        <Grid container>
                            <MDTypography variant="button" fontWeight="medium">COSTO ORDINI EFFETTIVO:</MDTypography>
                            <MDTypography variant="button" ml={1}>{toPrice(materialCost)}</MDTypography>
                        </Grid>
                        <Grid container>
                            <MDTypography variant="button" fontWeight="medium">COSTO TOTALE EFFETTIVO:</MDTypography>
                            <MDTypography variant="button" ml={1}>{toPrice(laborCost+materialCost)}</MDTypography>
                        </Grid>
                        <Grid container>
                            <MDTypography variant="button" fontWeight="medium">BUDGET DI COMMESSA EFFETTIVO:</MDTypography>
                            <MDTypography variant="button" ml={1}>{toPrice(budgetReale)}</MDTypography>
                        </Grid>
                        <Grid container>
                            <MDTypography variant="button" fontWeight="medium">MARK-UP EFFETTIVO:</MDTypography>
                            <MDTypography variant="button" ml={1}>{toPrice(markupReal)}</MDTypography>
                        </Grid>
                    </Grid>
                </Grid>
            </MDBox>
        )
    }




    render() {
        if (isAccordoQuadro(this.state.data)) { return this.renderAQ(); }


        if (!this.state.workerLoaded) { return null }
        if (!this.state.salLoaded) { return null }

        let totalDuration = this.totalDuration();

        let workedDays = getWorkedDaysNumber(this.state.worker);
        let endDate = calculateFinalDate(this.state.data.data_inizio, this.totalDuration(), (this.state.data.days_type == "Consecutivi" ? false : true))
        if (workedDays > totalDuration) { workedDays = totalDuration; }

        let materialCost = materialCostCommessa(this.state.data)
        let laborCost = laborCostCommessa(this.state.worker, null, null, this.state.data.id)


        let importoContrattuale = calculateImportoContrattuale(this.state.data, false)

        if (importoContrattuale == null) { importoContrattuale = 0 }

        let sal = calculateSAL(this.state.sal) / 100;
        let markupReal = calculateMarkupReal(this.state.data, materialCost, laborCost);

        let budget = (importoContrattuale - (importoContrattuale - (this.state.data.costo_ordini + this.state.data.costo_manodopera)))
        let budgetReale = calculateBudgetReal(this.state.data, markupReal)

        let dataStimata = calculateFinalDate(new Date(), this.totalDuration() - workedDays, (this.state.data.days_type == "Consecutivi" ? false : true))

        let scostamento = calculateFinalDate(toDashDate(endDate), daysBetween(endDate, dataStimata), (this.state.data.days_type == "Consecutivi" ? false : true), true);
        if (!scostamento) { scostamento = 0 }



        let materialCostPreventivati = 0;
        let laborCostPreventivati = 0;


        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    backButton={this.props.backFunction ? this.props.backFunction : null}
                    text={this.state.data.nome + " - Dettagli"}
                />


                <MDBox
                    bgColor="white"
                    borderRadius="lg"
                    shadow="lg"
                    p={2}
                >
                    <Grid container p={2} style={{ borderBottom: "1px solid #00000080" }}>
                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Importo contrattuale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(importoContrattuale)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Budget di commessa preventivato:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(budget)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni TOTALI:</MDTypography>
                                <MDTypography variant="button" ml={1}>{totalDuration}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Data fine lavori CONTRATTUALE:</MDTypography>
                                <MDTypography variant="button" ml={1}>{endDate}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container p={2} style={{ borderBottom: "1px solid #00000080" }}>
                        <Grid item sm={3}>
                            <Grid container>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        sx={{
                                            flexDirection: "row-reverse",
                                            padding: 0,
                                            minHeight: "unset!important",
                                            marginLeft: "-20px"
                                        }}
                                    >
                                        <MDTypography variant="button" fontWeight="medium">Costi preventivati:</MDTypography>
                                        <MDTypography variant="button" ml={1}>{toPrice(this.state.data.costo_ordini + this.state.data.costo_manodopera)}</MDTypography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: 0 }}>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo ordini preventivati:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(this.state.data.costo_ordini)}</MDTypography>
                                        </Grid>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo manodopera preventivati:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(this.state.data.costo_manodopera)}</MDTypography>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Budget di commessa reale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(budgetReale)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">{isAccordoQuadro(this.state.data) ? "Giorni PASSATI" : "Giorni LAVORATI"}</MDTypography>
                                <MDTypography variant="button" ml={1}>{workedDays}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Data fine lavori STIMATA:</MDTypography>
                                <MDTypography variant="button" ml={1}>{dataStimata}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid container p={2}>
                        <Grid item sm={3}>
                            <Grid container>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        sx={{
                                            flexDirection: "row-reverse",
                                            padding: 0,
                                            minHeight: "unset!important",
                                            marginLeft: "-20px"
                                        }}
                                    >
                                        <MDTypography variant="button" fontWeight="medium">Costi Totale ad oggi:</MDTypography>
                                        <MDTypography variant="button" ml={1}>{toPrice(materialCost + laborCost)}</MDTypography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: 0 }}>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo ordini ad oggi:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(materialCost)}</MDTypography>
                                        </Grid>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo manodopera ad oggi:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(laborCost)}</MDTypography>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Mark-up reale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(markupReal)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni MANCANTI:</MDTypography>
                                <MDTypography variant="button" ml={1}>{totalDuration - workedDays}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni di SCOSTAMENTO:</MDTypography>
                                <MDTypography variant="button" ml={1}>{scostamento}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>

                </MDBox>


                {this.renderYear(new Date("01/01/1990"), new Date("12/31/2100"), "GLOBALE", this.state.data)}
                {this.listYear(new Date(toDashDate(dataStimata)).getFullYear()).map((el) => {
                    return (this.renderYear(new Date("01/01/" + el), new Date("01/01/" + (el+1)),el,this.state.data));
                })}

            </DashboardLayout>
        )
    }

    /**
     * /5.066,40 �
COSTO ORDINI EFFETTIVO:
26.487,69 �
COSTO TOTALE EFFETTIVO:
31.554,09 �
BUDGET DI COMMESSA EFFETTIVO:
31.554,09 �
MARK-UP EFFETTIVO:
-24.554,09 �
     * @returns
     */

    renderAQ() {

        if (!this.state.workerLoaded) { return null }
        if (!this.state.salLoaded) { return null }

        let totalDuration = this.totalDuration();

        let workedDays = getWorkedDaysNumber(this.state.worker);
        workedDays = getAQPassedDays(this.state.data);

        let endDate = calculateFinalDate(this.state.data.data_inizio, this.totalDuration(), (this.state.data.days_type == "Consecutivi" ? false : true))
        if (workedDays > totalDuration) { workedDays = totalDuration; }

        //let materialCost = materialCostCommessa(this.state.data)
        //let laborCost = laborCostCommessa(this.state.worker, null, null, this.state.data.id)



        let importoContrattuale = 0;
        let materialCost = 0
        let laborCost = laborCostCommessa(this.state.worker, null, null, this.state.data.id)

        let materialCostPreventivati = 0;
        let laborCostPreventivati = 0;

        let temp = this.state.data
        temp.fattures = [];

        this.state.data.incarichi.map((el) => {
            el.fattures.map((fatt) => {
                temp.fattures.push(fatt);
            })
            importoContrattuale += el.preventivo;
            materialCost += materialCostCommessa(el)
            materialCostPreventivati += el.costo_ordini;
            laborCostPreventivati += el.costo_manodopera;
        })



        if (importoContrattuale == null) { importoContrattuale = 0 }
        let sal = calculateSAL(this.state.sal) / 100;
        let markupReal = calculateMarkupReal(this.state.data, materialCost, laborCost);

        let budget = (importoContrattuale - (importoContrattuale - (materialCostPreventivati + laborCostPreventivati)))
        let budgetReale = calculateBudgetReal(this.state.data, markupReal)

        let dataStimata = calculateFinalDate(new Date(), this.totalDuration() - workedDays, (this.state.data.days_type == "Consecutivi" ? false : true))

        let scostamento = calculateFinalDate(toDashDate(endDate), daysBetween(endDate, dataStimata), (this.state.data.days_type == "Consecutivi" ? false : true), true);
        if (!scostamento) { scostamento = 0 }
        scostamento = 0;
        dataStimata = endDate;


        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    backButton={this.props.backFunction ? this.props.backFunction : null}
                    text={this.state.data.nome + " - Dettagli"}
                />


                <MDBox
                    bgColor="white"
                    borderRadius="lg"
                    shadow="lg"
                    p={2}
                >
                    <Grid container p={2} style={{ borderBottom: "1px solid #00000080" }}>
                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Importo contrattuale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(importoContrattuale)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Budget di commessa preventivato:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(budget)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni TOTALI:</MDTypography>
                                <MDTypography variant="button" ml={1}>{totalDuration}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Data fine lavori CONTRATTUALE:</MDTypography>
                                <MDTypography variant="button" ml={1}>{endDate}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container p={2} style={{ borderBottom: "1px solid #00000080" }}>
                        <Grid item sm={3}>
                            <Grid container>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        sx={{
                                            flexDirection: "row-reverse",
                                            padding: 0,
                                            minHeight: "unset!important",
                                            marginLeft: "-20px"
                                        }}
                                    >
                                        <MDTypography variant="button" fontWeight="medium">Costi preventivati:</MDTypography>
                                        <MDTypography variant="button" ml={1}>{toPrice(materialCostPreventivati + laborCostPreventivati)}</MDTypography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: 0 }}>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo ordini preventivati:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(materialCostPreventivati)}</MDTypography>
                                        </Grid>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo manodopera preventivati:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(laborCostPreventivati)}</MDTypography>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Budget di commessa reale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(budgetReale)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni PASSATI</MDTypography>
                                <MDTypography variant="button" ml={1}>{workedDays}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Data fine lavori STIMATA:</MDTypography>
                                <MDTypography variant="button" ml={1}>{dataStimata}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid container p={2}>
                        <Grid item sm={3}>
                            <Grid container>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        sx={{
                                            flexDirection: "row-reverse",
                                            padding: 0,
                                            minHeight: "unset!important",
                                            marginLeft: "-20px"
                                        }}
                                    >
                                        <MDTypography variant="button" fontWeight="medium">Costi Totale ad oggi:</MDTypography>
                                        <MDTypography variant="button" ml={1}>{toPrice(materialCost + laborCost)}</MDTypography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: 0 }}>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo ordini ad oggi:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(materialCost)}</MDTypography>
                                        </Grid>
                                        <Grid container>
                                            <MDTypography variant="caption" fontWeight="medium">Costo manodopera ad oggi:</MDTypography>
                                            <MDTypography variant="caption" ml={1}>{toPrice(laborCost)}</MDTypography>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Mark-up reale:</MDTypography>
                                <MDTypography variant="button" ml={1}>{toPrice(markupReal)}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni MANCANTI:</MDTypography>
                                <MDTypography variant="button" ml={1}>{totalDuration - workedDays}</MDTypography>
                            </Grid>
                        </Grid>

                        <Grid item sm={3}>
                            <Grid container>
                                <MDTypography variant="button" fontWeight="medium">Giorni di SCOSTAMENTO:</MDTypography>
                                <MDTypography variant="button" ml={1}>{scostamento}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>

                </MDBox>

                {this.renderYear(new Date("01/01/1990"), new Date("12/31/2100"), "GLOBALE", temp)}
                {this.listYear(new Date(toDashDate(dataStimata)).getFullYear()).map((el) => {
                    return (this.renderYear(new Date("01/01/" + el), new Date("01/01/" + (el + 1)), el, temp));
                })}

            </DashboardLayout>
        )
    }

}




